import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import { withRouter } from 'react-router';
import Ad from '../../../components/ad/ad';
import Slug from '../../../components/slug/slug';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import MostCreativePeopleCommunitySection from '../../../components/most_creative_people_community_section/most_creative_people_community_section';
import Social from '../../../components/social/social';

// eslint-disable-next-line
class MostCreativePeopleCommunitySectionPage extends Component {
  constructor(props) {
    super(props);

    this.alphabet = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'y',
      'z'
    ];
  }

  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.mostCreativePeopleCommunitySectionPage.isLoading) {
      return (
        <section className="person-page">
          <article className="person-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const {
      mostCreativePeopleCommunitySectionData,
      mostCreativePeopleCommunitySectionNextData
    } = this.props;

    const adData = get(
      this.props,
      'mostCreativePeopleCommunitySectionPage.ads'
    );
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgTitle = 'The Most Creative People in Business Community';
    const pgDesc =
      'these inspiring leaders are shaping the future of business in creative ways.';
    const section = get(this.props, 'match.params.section');
    const page = Number(get(this.props, 'match.params.page'));
    const nextPage = page &&
      !isEmpty(mostCreativePeopleCommunitySectionNextData)
      ? String(page + 1)
      : null;
    const prevPage = page > 1 ? String(page - 1) : null;

    return (
      <section className={'person-index-page'}>
        <Ad {...combinedAdModel} name="oop" slug="false" oop="true" />
        <section className="page-title person-index-page__page-title">
          <Slug slugName={pgTitle} className="category-page" />
          <h3 className="page-description">{pgDesc}</h3>
        </section>

        <div className="mcp-community__section-container">
          <Social
            enableSticky={true}
            text={encodeURIComponent(
              'The Most Creative People In Business Community #FCMostCreative'
            )}
            uri="https://www.fastcompany.com/most-creative-people-community"
            modifier="mcp-community"
            bottomBoundary=".mcp-community-section--z"
            topValue={90}
          />
          {this.alphabet.map(letter =>
            <MostCreativePeopleCommunitySection
              combinedAdModel={combinedAdModel}
              index={letter}
              key={letter}
              people={mostCreativePeopleCommunitySectionData}
              prevPage={prevPage}
              nextPage={nextPage}
              activeSection={section}
            />
          )}
          <div className={'mcp-community-section__ff-ad-container'}>
            <Ad {...combinedAdModel} pos="btf" name="flexiblebillboard_1" />
            <Ad {...combinedAdModel} pos="btf" name="mobileparallax_1" />
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    mostCreativePeopleCommunitySectionData:
      get(state, 'mostCreativePeopleCommunitySection.data') || {},
    mostCreativePeopleCommunitySectionNextData:
      get(state, 'mostCreativePeopleCommunitySectionNext.data') || {},
    mostCreativePeopleCommunitySectionPage: Object.keys(
      get(state, 'mostCreativePeopleCommunityPage') || {}
    ).length
      ? get(state, 'mostCreativePeopleCommunityPage')
      : get(state, 'mostCreativePeopleCommunitySectionPage') || {}
  };
}

MostCreativePeopleCommunitySectionPage.propTypes = {
  status: PropTypes.number.isRequired,
  mostCreativePeopleCommunitySectionData: PropTypes.shape({}).isRequired,
  mostCreativePeopleCommunitySectionNextData: PropTypes.shape({}).isRequired,
  mostCreativePeopleCommunitySectionPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default withRouter(
  connect(mapStateToProps)(MostCreativePeopleCommunitySectionPage)
);



// WEBPACK FOOTER //
// ./src/views/containers/pages/most_creative_people_community_section_page/most_creative_people_community_section_page.js